module.exports = __webpack_public_path__ + "static/media/secondBlockAutomotive@2x.eeed27a3.jpg";